import { CardTheme } from './types';

interface BorderColorParams {
  theme: CardTheme;
  isActive?: boolean;
  isEnable?: boolean;
  readOnly?: boolean;
}

interface BlurColorParams {
  theme: CardTheme;
}

interface IconChartColorParams {
  theme: CardTheme;
  isActive?: boolean;
  isEnable?: boolean;
}

interface HoverShadowStylesParams {
  theme: CardTheme;
  isActive?: boolean;
  isEnable?: boolean;
}

export const getBorderColor = ({ theme, isActive, isEnable, readOnly }: BorderColorParams): string => {
  if (isActive && isEnable) {
    switch (theme) {
      case CardTheme.NEUTRAL:
        return 'border-[#A9B2C9]';
      case CardTheme.ORANGE:
        return 'border-[#F79824]';
      case CardTheme.GREEN:
        return 'border-[#3DA264]';
      case CardTheme.BLUE:
        return 'border-[#4879F6]';
      case CardTheme.BLUE_LIGHT:
        return 'border-[#5A9CFF]';
      case CardTheme.PURPLE:
        return 'border-[#A375B8]';
      case CardTheme.PURPLE_LIGHT:
        return 'border-[#CB6FF6]';
      case CardTheme.PINK:
        return 'border-[#ED96DA]';
      case CardTheme.RED:
        return 'border-red-40';
      case CardTheme.TEAL:
        return 'border-[#16AD89]';
      default:
        return 'border-[#D3D7DF]';
    }
  } else if (!readOnly && isEnable) {
    let hoverColor = '';
    switch (theme) {
      case CardTheme.NEUTRAL:
        hoverColor = 'hover:border-[#A9B2C9]';
        break;
      case CardTheme.ORANGE:
        hoverColor = 'hover:border-[#F79824]';
        break;
      case CardTheme.GREEN:
        hoverColor = 'hover:border-[#3DA264]';
        break;
      case CardTheme.BLUE:
        hoverColor = 'hover:border-[#4879F6]';
        break;
      case CardTheme.BLUE_LIGHT:
        hoverColor = 'hover:border-[#5A9CFF]';
        break;
      case CardTheme.PURPLE:
        hoverColor = 'hover:border-[#A375B8]';
        break;
      case CardTheme.PURPLE_LIGHT:
        hoverColor = 'hover:border-[#CB6FF6]';
        break;
      case CardTheme.PINK:
        hoverColor = 'hover:border-[#ED96DA]';
        break;
      case CardTheme.RED:
        hoverColor = 'hover:border-red-40';
        break;
      case CardTheme.TEAL:
        hoverColor = 'hover:border-[#16AD89]';
        break;
      default:
        hoverColor = 'bg-neutral-10';
    }

    return `border-[#D3D7DF] ${hoverColor}`;
  }
  return 'border-[#D3D7DF]';
};

export const getBlurColor = ({ theme }: BlurColorParams): string => {
  switch (theme) {
    case CardTheme.NEUTRAL:
      return 'bg-[#A9B2C9]';
    case CardTheme.ORANGE:
      return 'bg-[#F9B766]';
    case CardTheme.GREEN:
      return 'bg-[#3DA264]';
    case CardTheme.BLUE:
      return 'bg-[#4879F6]';
    case CardTheme.BLUE_LIGHT:
      return 'bg-[#5A9CFF]';
    case CardTheme.PURPLE:
      return 'bg-[#702A91]';
    case CardTheme.PURPLE_LIGHT:
      return 'bg-[#CB6FF6]';
    case CardTheme.PINK:
      return 'bg-[#D921B0]';
    case CardTheme.TEAL:
      return 'bg-[#16AD89]';
    default:
      return 'bg-neutral-10';
  }
};

export const getIconChartColor = ({ theme, isActive, isEnable }: IconChartColorParams): string => {
  if (isActive && isEnable) {
    switch (theme) {
      case CardTheme.NEUTRAL:
        return '#A9B2C9';
      case CardTheme.ORANGE:
        return '#F9B766';
      case CardTheme.GREEN:
        return '#3DA264';
      case CardTheme.BLUE:
        return '#4879F6';
      case CardTheme.BLUE_LIGHT:
        return '#5A9CFF';
      case CardTheme.PURPLE:
        return '#702A91';
      case CardTheme.PURPLE_LIGHT:
        return '#CB6FF6';
      case CardTheme.PINK:
        return '#D921B0';
      case CardTheme.RED:
        return '#E72547';
      case CardTheme.TEAL:
        return '#16AD89';
      default:
        return '#808080';
    }
  }
  return '#BFBFBF';
};

export const getHoverShadowStyles = ({ theme, isActive, isEnable }: HoverShadowStylesParams): string => {
  if (isActive && isEnable) {
    switch (theme) {
      case CardTheme.NEUTRAL:
        return 'hover:shadow-[0_0_3px_2px_rgba(73,92,140,0.35)]';
      case CardTheme.ORANGE:
        return 'hover:shadow-[0_0_3px_2px_rgba(247,152,36,0.35)]';
      case CardTheme.GREEN:
        return 'hover:shadow-[0_0_3px_2px_rgba(0,153,43,0.35)]';
      case CardTheme.BLUE:
        return 'hover:shadow-[0_0_3px_2px_rgba(68,118,246,0.35)]';
      case CardTheme.BLUE_LIGHT:
        return 'hover:shadow-[0_0_3px_2px_rgba(90,156,255,0.35)]';
      case CardTheme.PURPLE:
        return 'hover:shadow-[0_0_3px_2px_rgba(112,42,145,0.35)]';
      case CardTheme.PURPLE_LIGHT:
        return 'hover:shadow-[0_0_3px_2px_rgba(203,111,246,0.35)]';
      case CardTheme.PINK:
        return 'hover:shadow-[0_0_3px_2px_rgba(217,33,176,0.35)]';
      case CardTheme.TEAL:
        return 'hover:shadow-[0_0_3px_2px_rgba(22,173,137,0.35)]';
      default:
        return 'hover:shadow-[0_0_3px_2px_rgba(73,92,140,0.35)]';
    }
  }
  return 'hover:shadow-[0_0_2px_1px_rgba(0,0,0,0.15)]';
};
